import { dataLayerPush } from '@libs/analytics';
import { type FrefListCodes, getENV, resolveFrefListAttribution } from '@libs/common-next';
import { BuyItAgainItem } from '@libs/common-types';

import { resolvePrice } from './resolve-price';

type SelectProductAttribution = {
    position: number;
    frefAttribution: FrefListCodes;
};

export const useSelectProductEvent = (
    product: BuyItAgainItem,
    { position, frefAttribution }: SelectProductAttribution
) => {
    const { item_list_name, item_list_id } = resolveFrefListAttribution(frefAttribution);

    const sendSelectEvent = () => {
        dataLayerPush({ ecommerce: null });
        dataLayerPush({
            event: 'select_item',
            ecommerce: {
                currency: getENV('NEXT_PUBLIC_LOCALE') === 'en-CA' ? 'CAD' : 'USD',
                category: null,
                sub_category1: null,
                sub_category2: null,
                items: [
                    {
                        item_name: product.name,
                        item_id: product.webStyleId,
                        quantity: 1,
                        price: resolvePrice(product.price),
                        item_category: product.itemCategory,
                        item_category2: product.itemCategory2,
                        item_category3: product.itemCategory3,
                        item_category4: product.itemCategory4,
                        item_category5: product.itemCategory5,
                        item_brand: product.brand,
                        item_variant: product.sku,
                        index: position,
                        item_list_name,
                        item_list_id,
                        color: product.color,
                        size: product.size,
                        flavor: product.flavor,
                        item_search_term: null,
                    },
                ],
            },
        });
    };

    return sendSelectEvent;
};
